import { render } from "./ProjectFinanceSection.vue?vue&type=template&id=538773ef&scoped=true&ts=true"
import script from "./ProjectFinanceSection.vue?vue&type=script&lang=ts"
export * from "./ProjectFinanceSection.vue?vue&type=script&lang=ts"

import "./ProjectFinanceSection.vue?vue&type=style&index=0&id=538773ef&lang=scss&scoped=true"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-538773ef"]])

export default __exports__
import QMenu from 'quasar/src/components/menu/QMenu.js';
import QTabs from 'quasar/src/components/tabs/QTabs.js';
import QTab from 'quasar/src/components/tabs/QTab.js';
import QTabPanels from 'quasar/src/components/tab-panels/QTabPanels.js';
import QTabPanel from 'quasar/src/components/tab-panels/QTabPanel.js';
import QInput from 'quasar/src/components/input/QInput.js';
import QIcon from 'quasar/src/components/icon/QIcon.js';
import QBtn from 'quasar/src/components/btn/QBtn.js';
import QTooltip from 'quasar/src/components/tooltip/QTooltip.js';
import QCard from 'quasar/src/components/card/QCard.js';
import QCardSection from 'quasar/src/components/card/QCardSection.js';
import QAvatar from 'quasar/src/components/avatar/QAvatar.js';
import QCardActions from 'quasar/src/components/card/QCardActions.js';import ClosePopup from 'quasar/src/directives/close-popup/ClosePopup.js';
import qInstall from "../../../../../node_modules/vue-cli-plugin-quasar/lib/runtime.auto-import.js";
qInstall(script, 'components', {QMenu,QTabs,QTab,QTabPanels,QTabPanel,QInput,QIcon,QBtn,QTooltip,QCard,QCardSection,QAvatar,QCardActions});qInstall(script, 'directives', {ClosePopup});
